$shm_hitalama_text_embed $mol_embed_any
	Image_view $shm_hitalama_text_embed_image
		uri <= uri
		title <= title
